import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getProduct } from "@/data/products";

const CartContext = createContext(null);
const KEY = "borcelle-bag";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v.filter((i) => getProduct(i.slug)) : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const api = useMemo(() => {
    const add = (slug, finish, qty = 1) =>
      setItems((prev) => {
        const found = prev.find((i) => i.slug === slug && i.finish === finish);
        if (found) return prev.map((i) => (i === found ? { ...i, qty: i.qty + qty } : i));
        return [...prev, { slug, finish, qty }];
      });
    const setQty = (slug, finish, qty) =>
      setItems((prev) =>
        prev.flatMap((i) => (i.slug === slug && i.finish === finish ? (qty > 0 ? [{ ...i, qty }] : []) : [i]))
      );
    const lines = items.map((i) => {
      const p = getProduct(i.slug);
      const f = p.finishes.find((x) => x.id === i.finish) || p.finishes[0];
      return { ...i, product: p, finishObj: f, lineTotal: p.price * i.qty };
    });
    const total = lines.reduce((s, l) => s + l.lineTotal, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);
    return { items, lines, total, count, add, setQty, clear: () => setItems([]), open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={api}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
